import { ContactsIndexSchema } from '../schemas/ContactsIndexSchema';
import { ProductCategoriesIndexSchema } from '../schemas/ProductCategoriesIndexSchema';
import { ProductSectionsIndexSchema } from '../schemas/ProductSectionsIndexSchema';
import { ProductsIndexSchema } from '../schemas/ProductsIndexSchema';
import { WorksitesIndexSchema } from '../schemas/WorksitesIndexSchema';
export type Enum<TEnum> = TEnum[keyof TEnum];

export const MEILISEARCH_MODEL = {
    CONTACTS: 'contacts',
    PRODUCTS: 'products',
    PRODUCT_CATEGORIES: 'product_categories',
    PRODUCT_SECTIONS: 'product_sections',
    COMPOSED_WORK_LINES: 'composed_work_lines',
    WORKSITES: 'worksites',
} as const;

export type MeilisearchModel = Enum<typeof MEILISEARCH_MODEL>;

export type MeilisearchHit = {
    [MEILISEARCH_MODEL.CONTACTS]: ContactsIndexSchema;
    [MEILISEARCH_MODEL.PRODUCTS]: ProductsIndexSchema;
    [MEILISEARCH_MODEL.PRODUCT_CATEGORIES]: ProductCategoriesIndexSchema;
    [MEILISEARCH_MODEL.PRODUCT_SECTIONS]: ProductSectionsIndexSchema;
    [MEILISEARCH_MODEL.WORKSITES]: WorksitesIndexSchema;
};
